import { useQueryHook } from "@/hooks"
import { readVerify } from "@/app/api/auth"
import { UseQueryOptions } from "@tanstack/react-query"

import { ApiError } from "@/app/api/type"

export const useVerifyQuery = (token?: string) => {
  return useQueryHook<void, ApiError>({
    queryKey: ["readVerify", token],
    queryFn: () => readVerify(token || ""),
    options: {
      enabled: !!token,
    } as UseQueryOptions<void, ApiError>,
  })
}
